// Guardado de los formularios discretos con error visible (2026-09-13). Antes
// cada formulario hacía `setGuardando(true)` → `await createResource(...)` →
// `setGuardando(false)` sin try/finally: si Medplum rechazaba (403 de
// AccessPolicy, red, validación) el botón quedaba deshabilitado para siempre
// y sin ningún mensaje — la hipótesis vigente del "013A colgado".
import { normalizeErrorString } from '@medplum/core';
import { useCallback, useState } from 'react';

type Setters = { setGuardando: (v: boolean) => void; setError: (v: string | null) => void };

/** Lógica pura (testeable sin React): siempre libera el botón y convierte el fallo en texto. */
export async function ejecutarGuardado(fn: () => Promise<void>, { setGuardando, setError }: Setters): Promise<void> {
  setGuardando(true);
  setError(null);
  try {
    await fn();
  } catch (err) {
    setError(normalizeErrorString(err));
  } finally {
    setGuardando(false);
  }
}

export function useGuardado(): { guardando: boolean; error: string | null; guardar: (fn: () => Promise<void>) => Promise<void> } {
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const guardar = useCallback((fn: () => Promise<void>) => ejecutarGuardado(fn, { setGuardando, setError }), []);
  return { guardando, error, guardar };
}
